var React = require('react');

function LinkArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.7145 7.6626L24.7145 7.66299L24.7173 7.6626V21.6307L21.7173 21.6307V12.7839L8.10028 26.4009L5.97896 24.2796L19.5987 10.6598H10.7464L10.7464 7.65984H24.7145L24.7145 7.6626Z","fill":"#1F1F1F"}));
}

LinkArrowInline.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = LinkArrowInline;

LinkArrowInline.default = LinkArrowInline;
